import { useMemo } from "react";
import { Dropdown } from "primereact/dropdown";
import { useGlobalState } from "../globalState/GlobalStateProvider";
import { GlobalSaveData } from "../globalState/GlobalSaveData";
import useFranquias from "../../hooks/useFranquias";

const TopbarFranquia = () => {
  const {state} = useGlobalState();
  const { franquias, loading } = useFranquias();

  const changeFranquia = (value:any) => {
    state.user.franquiaSelected = value
    GlobalSaveData("user", state.user);
    window.location.reload()
  }

  const nomeFranquiaSelecionada = state.user?.franquiaSelected?.nome;

  const franquiaSelecionada = useMemo(() => {
    if(!nomeFranquiaSelecionada){
      return null
    }
    return franquias.find((s:any) => s.nome === nomeFranquiaSelecionada) || null
  },[franquias, nomeFranquiaSelecionada])

  return (
    <div style={{paddingRight:'2rem'}}>
      <Dropdown value={franquiaSelecionada} onChange={(e) => changeFranquia(e.value)} className="franquia " style={{ width: '300px'}} options={franquias} optionLabel="nome"
        placeholder={loading ? 'Carregando...' : 'Selecione Franquia'} filter showClear />

    </div>
  );
};

export default TopbarFranquia;
